/**
 * Sdílený node-aware MCP scope pro toolbox panely a resources limiter.
 */
import { callWidgetTool } from '../../../widgets/scope';
import type { EffectiveScope } from '../../../widgets/types';

let _widgetScope: EffectiveScope = { node: null, identity: null };

export function setToolboxWidgetScope(scope: EffectiveScope) {
  _widgetScope = scope;
}

export function getToolboxWidgetScope(): EffectiveScope {
  return _widgetScope;
}

export function callMcp<T = unknown>(
  name: string,
  args: Record<string, unknown> = {},
): Promise<T> {
  return callWidgetTool(name, args, _widgetScope) as Promise<T>;
}

export function scopeKey() {
  return _widgetScope.node ?? 'local';
}
